export function crToPb(cr?: string | null) {
	if (!cr) return 0;
	const crNumber = parseInt(cr);
	if (isNaN(crNumber)) return 0;
	if (crNumber < 5) return 2;
	return Math.ceil(crNumber / 4) + 1;
}
